import { ChatStore } from "@/stores/ChatStore";
import type { ResponseCreated } from "@/types";
import { v4 } from "uuid";
import { bbLog } from "@/lib/blockbrainTrace";

export default function onReceivedResponseCreated(message: ResponseCreated) {
  console.log("Response created ", message);
  const waiting = ChatStore.getState().isWaitingForBlockbrain;
  if (waiting) {
    bbLog("realtime.responseCreated.keepWaiting", {
      responseId: (message as { response?: { id?: string } })?.response?.id,
    });
  }

  // Reset deltaBuffer for the new response to prevent old sentences from being spoken
  ChatStore.getState().resetDeltaBuffer();
  
  // Increment response session ID to signal InteractiveAvatar to reset its state
  ChatStore.getState().incrementResponseSessionId();

  // Create an empty assistant message to indicate that the assistant is responding
  // value is set in onReceivedResponseAudioTranscriptDelta()
  ChatStore.getState().addMessage({
    id: v4(),
    transcript: "",
    sender: "assistant",
    timestamp: new Date(),
  });

  // Note: We do NOT clear isWaitingForBlockbrain here. response.created is also
  // emitted for the function_call response (within ~100ms of the user turn),
  // long before Blockbrain has actually answered. The spinner is cleared in
  // onReceivedResponseAudioTranscriptDelta when the first real audio token of
  // the spoken answer arrives.
  if (!waiting) {
    ChatStore.getState().setAvatarStatus("Sprechen");
  }
}

